import { RefObject, useEffect, useState } from 'react';

type Options = {
  enabled: boolean;
  behavior?: ScrollBehavior;
  /**
   * Duration in milliseconds for which the element remains highlighted after scroll.
   * @default 2000
   */
  highlightDuration?: number;
};

type UseScrollIntoViewResult = {
  highlight: boolean;
};

export function useScrollIntoView<T extends HTMLElement>(
  ref: RefObject<T>,
  { enabled, behavior = 'smooth', highlightDuration = 2000 }: Options,
): UseScrollIntoViewResult {
  const [highlight, setHighlight] = useState(false);

  useEffect(() => {
    if (enabled) {
      ref.current?.scrollIntoView({ behavior, block: 'center' });
      setHighlight(true);
      const timeout = setTimeout(() => setHighlight(false), highlightDuration);
      return () => clearTimeout(timeout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  return { highlight };
}
